import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { usePriceRowContext } from '../../../../price-row-context';
import RatingSmiley from 'src/components/rating/smiley-rating';
import formatNumber from 'src/globals/helpers/format-number';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { StyledSeparator, StyledStoreLink, StyledStoreReviews } from './styles';

interface IStoreReviews {
  reviewCount: number;
  storeLink: string;
}

export const StoreReviews: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IStoreReviews>>
> = props => {
  const { reviewCount, storeLink } = props;
  const { isFeatured = false, offer } = usePriceRowContext();
  const { rating } = offer;
  const { market, t } = useAppContext();

  return (
    <StyledStoreReviews>
      {rating && (
        <>
          <RatingSmiley
            featured={isFeatured}
            rating={rating}
            scoreVisibility="row"
          />
          <StyledSeparator>|</StyledSeparator>
        </>
      )}
      <StyledStoreLink
        to={storeLink}
        aria-label={t('reviews', 'rating.n-reviews', {
          n: reviewCount,
          count: formatNumber(reviewCount, market.code),
        })}
        data-test="StoreInfoLink"
        tabIndex={0}
        onClick={() =>
          trackInternalNavigationClick({
            scope: InternalNavigationScope.STORE_REVIEW,
            nextPage: storeLink,
          })
        }
      >
        {t('reviews', 'rating.n-reviews', {
          n: reviewCount,
          count: formatNumber(reviewCount, market.code),
        })}
      </StyledStoreLink>
    </StyledStoreReviews>
  );
};
